var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletBlossom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.388,
    height: 23.411,
    viewBox: "0 0 23.388 23.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 23.388,
    height: 23.411,
    fill: "#b0e59a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bullet-blossom",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M23.388,11.832a2.143,2.143,0,0,0-2.14-2.141H19.463L21.011,8.8a2.14,2.14,0,1,0-2.14-3.707l-1.389.8.8-1.381a2.141,2.141,0,0,0-3.707-2.141l-.754,1.306V2.14a2.14,2.14,0,1,0-4.28,0V3.6l-.732-1.27A2.141,2.141,0,0,0,5.1,4.475L5.96,5.97,4.46,5.1A2.14,2.14,0,0,0,2.32,8.812l1.271.733H2.139a2.141,2.141,0,0,0,0,4.281H3.661L2.311,14.6a2.141,2.141,0,0,0,2.141,3.707L5.86,17.5l-.824,1.427a2.14,2.14,0,0,0,3.707,2.14l.774-1.34v1.545a2.14,2.14,0,1,0,4.28,0V19.778l.77,1.332a2.14,2.14,0,0,0,3.707-2.14L17.4,17.462l1.482.855a2.141,2.141,0,0,0,2.141-3.707l-1.1-.637h1.326a2.143,2.143,0,0,0,2.14-2.14",
    transform: "translate(0 0)",
    fill: "#b0e59a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletBlossom);
export default __webpack_public_path__ + "static/media/bullet-blossom.49eaaec2a37ea01b5a037d50a899504a.svg";
export { ForwardRef as ReactComponent };